<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card no-header>
          <template slot="header">Información de la Novedad</template>
          <b-table class="datos-objeto" responsive="sm" 
              :items="personalNovedadDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'personalNovedad/getField',
  mutationType: 'personalNovedad/updateField',
});

export default {
  name: 'PersonalNovedadesData',
  components: {
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data() {
    return {
      id: 0,
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],
    }
  },
  computed: {
    ...mapFields([
      'personalNovedadDatos',
    ])
  },
  created() {
    this.personalNovedadId= this.$route.params.id

    this.showSpinner();
    this.$store.dispatch('personalNovedad/getDatos', this.personalNovedadId)
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    goBack() {
      this.$router.push({ name: "PersonalNovedades" });
      // this.$router.go(-1);
    }
  }
}
</script>

<style>
</style>